export const SOCIAL_LINKS = {
    telegram: 'https://t.me/Raffle_Rooms_X',
}